const state = {
  isMobile: window && window.innerWidth < 991
};

const getters = {
  isMobile: state => state.isMobile
};

const action = {};

const mutations = {
  setIsMobile(state, isMobile) {
    state.isMobile = isMobile;
  }
};

export default {
  state,
  getters,
  action,
  mutations
};
